import { useLocation } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import BenefitsLandingContent from './_Content/BenefitsLandingContent'
import { getBenefitsLandingContent } from './_Content/countryContent'
import BenefitsLandingFooter from './_Footer/BenefitsLandingFooter'
import BenefitsLandingHeader from './_Header/BenefitsLandingHeader'

const BenefitsLandingPage = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const {
    company: { legalEntities },
  } = useCurrentSession()

  const mainLegalEntity = legalEntities.find((entity) => entity.main)
  const mainCountry = mainLegalEntity?.country?.toLowerCase()
  const content = getBenefitsLandingContent(mainCountry)

  useEffect(() => {
    track(trackingEvents.benefits.openBenefitsLanding, {
      source: 'benefits-landing',
      origin: queryParams.get('origin'),
    })
  }, [location.search])

  return (
    <ResponsivePage.Body showHeader={false} variant="full">
      <Box gap="s32">
        <BenefitsLandingHeader content={content} />
        <div className="border-0 border-b border-dashed border-white w-full h-8 opacity-10"></div>
        <BenefitsLandingContent content={content} />
        <div className="border-0 border-b border-dashed border-white w-full h-8 opacity-10 mb-12"></div>
        <BenefitsLandingFooter content={content} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default BenefitsLandingPage
